import React, { useCallback } from "react";
import { connect } from "react-redux";

import confirmExit from "@app/component/confirmExit";
import { exitTerritoryMode, setTerritoryMode } from "@app/scene/map/store/territoryMode/actions";
import {
  doesTerritoryEditFormHaveChanges,
  getTerritoryMode,
} from "@app/scene/map/store/territoryMode/selectors";
import TerritoryModeState from "@app/scene/map/store/territoryMode/TerritoryModeState";
import { RootState } from "@app/store/rootReducer";

import CreationBanner from "./CreationBanner";
import EditBanner from "./EditBanner";
import ViewBanner from "./ViewBanner";

interface Props {
  hasChanges?: boolean;
  mode: TerritoryModeState["mode"];
  onChangeMode: typeof setTerritoryMode;
  onExitTerritoryMode?: typeof exitTerritoryMode.request;
}

const Banner: React.FC<Props> = ({ hasChanges, mode, onChangeMode, onExitTerritoryMode }) => {
  const handleCancel = useCallback(async () => {
    if (hasChanges) {
      const canLeave = await confirmExit();
      if (!canLeave) {
        return;
      }
    }

    onChangeMode?.("view");
  }, [hasChanges, onChangeMode]);

  return mode === "create" ? (
    <CreationBanner onCancel={onExitTerritoryMode} />
  ) : mode === "edit" ? (
    <EditBanner onCancel={handleCancel} />
  ) : mode === "view" ? (
    <ViewBanner onCancel={onExitTerritoryMode} />
  ) : null;
};

const mapStateToProps = (state: RootState) => ({
  hasChanges: doesTerritoryEditFormHaveChanges(state),
  mode: getTerritoryMode(state),
});

const mapDispatchToProps = {
  onChangeMode: setTerritoryMode,
  onExitTerritoryMode: exitTerritoryMode.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
